import { Component, inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { LegalizationFileDto } from 'src/app/models/legalization-file-dto';
import { map } from 'rxjs';
import { WorkerFileTypeDto } from '../../../models/dtos/worker-file-type-dto';
import { WorkerFileTypeEnum } from '../../../models/enums/worker-file-type-enum';
import { DictionaryService } from '../../../data/dictionary.service';

@Component({
    template: ''
})
export abstract class SaveLegalizationInfoBaseComponent {
    protected dictionaryService = inject(DictionaryService);

    protected files: File[];
    protected result: LegalizationFileDto[] = [];
    protected isDocumentUploaded: boolean = false;
    private maxFileCount: number;

    constructor() {
        this.maxFileCount$.subscribe(count => this.maxFileCount = count);
    }

    protected readonly maxFileCount$ = this.dictionaryService
        .getWorkerFileTypeById(WorkerFileTypeEnum.LegalizationFile)
        .pipe(map((fileType: WorkerFileTypeDto) => fileType.CountLimit));

    protected onFilesChange(files: File[]): void {
        this.result = [];
        this.files = files;
        this.isDocumentUploaded = !!this.files;

        this.files.forEach((element) => {
            let file = new LegalizationFileDto();
            file.OriginalName = element.name;
            let reader = new FileReader();
            reader.onload = () => {
                file.FileContent = reader.result.toString();
                this.result.push(file);
            };

            reader.readAsDataURL(element);
        });
    }

    protected isFileCountValid(): boolean {
        return this.files && this.files.length > 0 && this.files.length <= this.maxFileCount;
    }

    protected updateValidatorBasedOnCondition(control: UntypedFormControl, condition: boolean): void {
        if (condition) {
            control.setValidators([Validators.required]);
        } else {
            control.clearValidators();
        }
        control.updateValueAndValidity();
    }
}
